var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}]},[_vm._l((_vm.list),function(item,i){return _c('SystemItem',{key:i,staticClass:"mb-3",attrs:{"messageRecord":item}})}),_c('loading',{attrs:{"isShowLoading":_vm.isShowLoading}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }